import { render } from "./GithubStats.vue?vue&type=template&id=29f481c8&scoped=true"
import script from "./GithubStats.vue?vue&type=script&lang=js"
export * from "./GithubStats.vue?vue&type=script&lang=js"

import "./GithubStats.vue?vue&type=style&index=0&id=29f481c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f481c8"]])

export default __exports__